import "assets/main.css"
import "assets/base.scss"
// import "assets/index.css"
import "assets/swiper.scss"
import "assets/loading.scss"
import "swiper/css"
import dynamic from "next/dynamic"
import { useEffect } from "react"
import * as Sentry from "@sentry/nextjs"
import { Head, SentryErrorBoundary } from "components/common"
import { StoreProvider } from "components/ui/Context"
import useStore from "components/ui/Context"
import NextNprogress from "nextjs-progressbar"
import { GoogleOAuthProvider } from "@react-oauth/google"
import KEY from "../utils/Const"
import PopupModal from "components/PopupModal/PopupModal"
import ModalLive from "components/ModalLive"
import ModalBan from "components/ModalBan"

const ModalLogin = dynamic(() => import("components/ModalLogin"), { ssr: false })

const Noop = ({ children }) => <>{children}</>

/**
 * Syncs the authenticated user from global store into Sentry.
 * Must be a child of StoreProvider so it can read the context.
 * Calls Sentry.setUser(null) on logout to clear identity.
 */
function SentryUserSync() {
  const { userInfo } = useStore()

  useEffect(() => {
    if (userInfo && (userInfo.id || userInfo.user_id || userInfo.email)) {
      Sentry.setUser({
        id: userInfo.id || userInfo.user_id,
        username: userInfo.username || userInfo.full_name,
        email: userInfo.email
      })
    } else {
      Sentry.setUser(null)
    }
  }, [userInfo])

  return null
}

function MyApp({ Component, pageProps }) {
  const Layout = Component.Layout || Noop

  const showPopup = (() => {
    if (typeof window === "undefined") return false
    const params = new URLSearchParams(window.location.search)
    return !!(params.get("p") && params.get("redirectUrl"))
  })()

  return (
    <GoogleOAuthProvider clientId={KEY.KEY_GOOGLE}>
      <NextNprogress
        color="#52b5f9"
        startPosition={0.3}
        stopDelayMs={200}
        height={3}
        showOnShallow={true}
        options={{ easing: "ease", speed: 500, showSpinner: false }}
      />
      <Head />
      <StoreProvider>
        <SentryUserSync />
        <SentryErrorBoundary>
          {typeof Component.Layout === "function" ? (
            <Layout pageProps={pageProps}>
              {({ isCollapsed }) => <Component isCollapsed={isCollapsed} {...pageProps} />}
            </Layout>
          ) : (
            <Layout>
              <Component {...pageProps} />
            </Layout>
          )}
          <ModalLogin defaultOpen={showPopup} />
          <PopupModal />
          <ModalLive />
          <ModalBan />
        </SentryErrorBoundary>
        <div id="fb-root"></div>
        <div id="modal-root"></div>
        <div id="toast-root"></div>
      </StoreProvider>
    </GoogleOAuthProvider>
  )
}

export default MyApp
